import _ from 'lodash'

export const rootNoteIds = (state) => {
  return (state.currentUser || {}).rootItems || []
}

export const sessionNames = (state) => {
  return _.map((state.currentUser || {}).sessions || [], (v, i) => { return { label: v.name, value: i } })
}

export const userSessions = (state) => {
  return (state.currentUser || {}).sessions || []
}
